import {
  BackgroundColors,
  ErrorColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { mediaQuery } from '@picsart/rc/helpers';

const useStyles = createUseStyles(
  () => ({
    root: {
      backgroundColor: BackgroundColors.base,
      width: '100%',
      padding: [Spacings.s0, Spacings.s16],
    },
    layout: {
      padding: [Spacings.s64, Spacings.s0],
      maxWidth: 1080,

      [mediaQuery(BreakPoints.Large)]: {
        maxWidth: 830,
      },
      // // [mediaQuery(767)]: {
      // '@media screen and (max-width: 767px)': {
      //   flexDirection: 'column',
      // },
      // [mediaQuery(764)]: {
      '@media screen and (max-width: 767px)': {
        flexDirection: 'column',
        maxWidth: 376,
        padding: [Spacings.s64, Spacings.s16],
        margin: [Spacings.s0, 'auto'],
      },
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      grid: "'head head head . . .' 'head head head a a a' '. b b a a a' '. b b a a a' '. b b c c .' '. . . c c .'",
      columnGap: Spacings.s24,
      rowGap: Spacings.s16,

      [mediaQuery(BreakPoints.Large)]: {
        gridTemplateColumns: '0fr 5fr 5fr 1fr',
        grid: "'head head . .' 'head head a a' '. b a a' '. b a a' '. b c .' '. . c .'",
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '1fr',
        grid: "'head' 'a' 'b' 'c'",
        rowGap: Spacings.s16,
      },
    },
    area: {
      position: 'relative',

      '&.area-head': {
        gridArea: 'head',
      },
      '&.area-0': {
        gridArea: 'a',
      },
      '&.area-1': {
        gridArea: 'b',
      },
      '&.area-2': {
        gridArea: 'c',
      },
    },
    textBlock: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: 540,
      height: 196,

      '& $title, & $desc': {
        width: 360,
      },

      [mediaQuery(BreakPoints.Large)]: {
        alignItems: 'flex-end',
        width: 360,

        '& $title, & $desc': {
          width: 300,
        },
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        maxWidth: 334,

        '& $title, & $desc': {
          width: 246,
        },
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        alignItems: 'flex-start',
      },
    },
    quotes: {
      display: 'block',
      position: 'absolute',
      opacity: 0.3,
      top: Spacings.s8,
      left: 0,
      width: 144,
      height: 120,
      fill: ErrorColors.base.default,

      // // [mediaQuery(764)]: {
      // '@media screen and (max-width: 767px)': {
      //   width: 60,
      //   height: 60,
      // },
      [mediaQuery(BreakPoints.Large)]: {
        top: 0,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        position: 'initial',
        marginBottom: Spacings.s12,
        width: 60,
        height: 60,
      },
    },
    title: {
      marginBottom: Spacings.s8,
      fontSize: FontSizes.s42,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l48,
      color: TextColors.base,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l36,
        marginBottom: Spacings.s24,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l24,
      },
    },
    desc: {
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l32,
      color: TextColors.base,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l24,
      },
    },

    //  SKELETON
    areaFallback: {
      '&.area-0': {
        height: 252,
      },
      '&.area-1': {
        height: 284,
      },
      '&.area-2': {
        height: 316,
      },
    },
    quotesFallback: {
      width: 120,
      height: 120,
      backgroundColor: ErrorColors.base.default,
      borderRadius: CornerRadius.r8,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: 72,
      },
    },
    titleFallback: {
      height: 96,
      opacity: 0.5,
    },
    descFallback: {
      height: 32,
      opacity: 0.5,
    },
  }),
  {
    name: 'testimonial-with-titles',
  },
);

export default useStyles;
